import getMarkers from "./getMarkers";

export default async function getCategories(): Promise<{[k: string]: { name: string }}> {
    const markers = await getMarkers();

    return markers.categories;
}